// Scales icon sizes that sit directly next to scaled text (item checkboxes,
// section/subgroup expand chevrons, inline edit affordances) so they stay
// visually balanced against the larger font-scale tiers. See
// context/FontScaleContext.tsx and index.css for the text-side of this
// feature. Deliberately narrow in scope - nav/header/dialog icons are left
// alone (PLAN discussion: only content-adjacent icons scale).
import type { FontScale } from "./displayPrefs.js";

const MULTIPLIER: Record<FontScale, number> = {
  normal: 1,
  large: 1.15,
  "x-large": 1.3,
  "xx-large": 1.45,
  "xxx-large": 1.6,
};

/** Rounds to the nearest even pixel so icon strokes stay crisp. */
export function scaledIconPx(basePx: number, scale: FontScale): number {
  return Math.round((basePx * MULTIPLIER[scale]) / 2) * 2;
}
